// extracted by mini-css-extract-plugin
export default {"titleBlock":"styles_titleBlock__c-pGd","title":"styles_title__weB7t","subTitle":"styles_subTitle__dFArz"};